module.exports = __webpack_public_path__ + "img/02d.f87cfdb2.png";